import React from "react";
import SysStatsMemReport from "./Report";
import View from "common/View";
import help from "help/viewSysStatsMem.md";

const SysStatsMem = ({returnView = null}) => {
  return (
    <View
      title="System Memory Usage Over Time"
      mdHelp={help}
      returnView={returnView}
    >
      <SysStatsMemReport returnView={returnView} />
    </View>
  );
};

export default SysStatsMem;
